import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-100 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 상단 링크 섹션 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* 서비스 안내 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">서비스 안내</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/obituaries/create" className="text-gray-300 hover:text-white transition-colors">
                  부고 작성
                </Link>
              </li>
              <li>
                <Link to="/obituaries" className="text-gray-300 hover:text-white transition-colors">
                  부고 찾기
                </Link>
              </li>
              <li>
                <Link to="/wreaths" className="text-gray-300 hover:text-white transition-colors">
                  화환 보내기
                </Link>
              </li>
              <li>
                <Link to="/support/guide" className="text-gray-300 hover:text-white transition-colors">
                  사용 설명서
                </Link>
              </li>
            </ul>
          </div>

          {/* 고객 지원 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">고객 지원</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/support/notices" className="text-gray-300 hover:text-white transition-colors">
                  공지사항
                </Link>
              </li>
              <li>
                <Link to="/support/faq" className="text-gray-300 hover:text-white transition-colors">
                  자주 묻는 질문
                </Link>
              </li>
              <li>
                <Link to="/support/inquiry" className="text-gray-300 hover:text-white transition-colors">
                  1:1 문의
                </Link>
              </li>
            </ul>
          </div>

          {/* 회사 정보 */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">회사 정보</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/company" className="text-gray-300 hover:text-white transition-colors">
                  회사 소개
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="text-gray-300 hover:text-white transition-colors">
                  이용약관
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="text-gray-300 hover:text-white transition-colors">
                  개인정보처리방침
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* 사업자 정보 */}
        <div className="border-t border-gray-700 pt-6 mb-6">
          <div className="text-sm text-gray-400 space-y-1">
            <p>상호명: 모바일 장례 서비스</p>
            <p>대표자: 홍길동</p>
            <p>사업자등록번호: 123-45-67890</p>
            <p>주소: 서울특별시 강남구 테헤란로 123</p>
            <p>전화: 02-1234-5678 | 이메일: contact@funeral-service.com</p>
          </div>
        </div>

        {/* 저작권 */}
        <div className="border-t border-gray-700 pt-6">
          <p className="text-sm text-gray-500 text-center">
            © {currentYear} 모바일 장례 서비스. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
